const missionControlVersion = "0.297.1";

export default missionControlVersion;
